import React, {useState , useEffect, useContext , useRef, useCallback} from "react";
import '../components/trip-create/trip-create.style.scss';
import { TripCreateRoute } from "../components/trip-create/trip-create-root";
import { useDispatch , useSelector} from 'react-redux';
import { tripCreateReducerSelector } from "../selector/trip-create.selector";
import { fetchMaterCitiesAction, getBusDetailsAction, setActiveCity, setSelectedCities } from "../actions/trip-create.actions";
import { isValidArray } from "../utils/utilities";
import { TripBottomRibbon } from "../components/trip-create/trip-bottom-ribbon";
import {VerifyTrip} from './../components/trip-create/verify-trip/verify-trip.component';
import {DirectFinalSummary} from './../components/trip-create/verify-trip/direct-final-summary.component';
import { message , Steps as WebSteps } from "antd";
import { Steps as MobileSteps} from 'antd-mobile';
import { useLocation } from "react-router-dom";
import { DeviceContext } from "../components/device-provider/device-provider";
import { setMapDirections } from "../actions/map-directions.action";
import { getWayPointsCities } from './../components/trip-create/trip-create.module';



export const TripCreatePage = (props) => {

  const [addStop, setAddStop] = useState(false);
  const [showRibbon, setShowRibbon] = useState(false);
  const [showVerifyPage, setShowVerifyPage] = useState(false);
  const [stepDataVal, setStepDataVal] = useState({})
  const [headerStep, setHeaderStep] = useState(0);
  const [selectedSeatNumbers, setSelectedSeatNumbers] = useState([]);
  const [showSelectCity, setShowSelectCity] = useState(false);
  const [distance, setDistance] = useState(0);
  const [duration, setDuration] = useState(0);
  const [citiesChanged, setCitiesChanged] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [busFormData, setBusFormData] = useState(null);
  const [partnerSelected, setSelectedPartner] = useState(null);
  const childRef = useRef();

  // Temporary add-city flow entry from the Manage Cities modal (location.state).
  const location = useLocation();
  const temporaryFlowState = location.state && location.state.temporaryCityFlow === true ? location.state : null;
  const [temporaryFlowInitialized, setTemporaryFlowInitialized] = useState(false);

  let customClassName = '';

  // if(enableLocationPick){
  //   customClassName = 'disabledDiv';
  // }else{
  //   customClassName = '';
  // }

  const {
    isMobile
  } = useContext(DeviceContext);

  const dispatch = useDispatch();
  const tripCreateReducer = useSelector(tripCreateReducerSelector);

  let {masterCities, busesData, isTripCityCreated, tripScheduleId, selectedCities } = tripCreateReducer

  useEffect(()=>{
    dispatch(fetchMaterCitiesAction());
    dispatch(getBusDetailsAction());
  },[]);

  const resetAllData=()=>{
    setSelectedMasterCities([]);
    setAddStop(false);
    setShowRibbon(false);
    setShowVerifyPage(false);
    setStepDataVal({});
    setHeaderStep(0);
    setSelectedSeatNumbers([]);
    setShowSelectCity(false);
    setDistance(0);
    setDuration(0);
    setSelectedMethod(null);
    setBusFormData(null);
  }

  useEffect (() => {
    if (isTripCityCreated && selectedMethod=="map"){
      setShowRibbon(true);
    }
    else{
      setShowRibbon(false);
    }
  },[isTripCityCreated, selectedMethod]);

  // Temp flow: once trip cities load, append the new city and jump to Add Stops.
  useEffect(() => {
    if (!temporaryFlowState || temporaryFlowInitialized || !isTripCityCreated || !isValidArray(selectedCities)) {
      return;
    }
    const newCity = temporaryFlowState.newCity;
    const alreadyAdded = selectedCities.some((city) => city.city_name === newCity.city_name);
    let newCityEntry = selectedCities.find((city) => city.city_name === newCity.city_name);
    if (!alreadyAdded) {
      newCityEntry = {
        city_name: newCity.city_name,
        latitude: newCity.latitude,
        longitude: newCity.longitude,
        isOrigin: true,
        isDestination: true
      };
      setSelectedMasterCities([...selectedCities, newCityEntry]);
    }
    setSelectedMethod("time");
    setStepDataVal({ 'headerFormPos': 1 });
    dispatch(setActiveCity(newCityEntry));
    setAddStop(true);
    setHeaderStep(2);
    setTemporaryFlowInitialized(true);
  }, [temporaryFlowState, temporaryFlowInitialized, isTripCityCreated, selectedCities]);

  const resetPages = () => {
    // Don't reset addStop here to preserve stops data when navigating between steps
    setShowVerifyPage(false);
    setShowSelectCity(false);
  }


  const onCallBackSetDirections=(data)=>{
    setSelectedMasterCities(data);
    let newOptions = getWayPointsCities(data);
    dispatch(setMapDirections(newOptions,false));
  }

  const setSelectedMasterCities=(data)=>{
    dispatch(setSelectedCities(data));
  }

  const changeSteps = useCallback((value) => {

    // Validate step progression
    let canProceed = true;
    let errorMessage = '';

    // Temp flow: bus/city selection steps are off-limits (schedule template).
    if (temporaryFlowState && value < 2) {
      message.error("Bus and city selection cannot be changed while adding a temporary city");
      return;
    }

    switch(value){
      case 0:{
        // Always allow going back to step 0 (Select Bus)
        // But preserve the selected method and bus data
        setHeaderStep(value);
        setStepDataVal({'headerFormPos': 0});
        // Don't reset selectedMethod - preserve the selection
        resetPages();
        return;
      }
      case 1: {
        // Check if bus selection is complete
        if (!busFormData) {
          canProceed = false;
          errorMessage = "Please complete bus selection first";
        }
        break;
      }
      case 2: {
        // Check if cities are selected - use selectedCities directly instead of isTripCityCreated
        if (!selectedCities || selectedCities.length < 2) {
          canProceed = false;
          errorMessage = "Please select at least 2 cities before adding stops";
        }
        break;
      }
      case 3: {
        // Check if we have cities selected and are coming from a valid state
        if (!selectedCities || selectedCities.length < 2) {
          canProceed = false;
          errorMessage = "Please select at least 2 cities before verification";
        }
        break;
      }
    }
    
    if (!canProceed) {
      message.error(errorMessage);
      return; // Don't proceed to the step
    }
    
    // Set the step
    setHeaderStep(value);
    
    // Reset pages when changing steps
    resetPages();
    
    switch(value){
      case 1: {
        setStepDataVal({'headerFormPos': 1});
        // Reset addStop when moving to step 1 (Select Cities)
        setAddStop(false);
        break;
      }
      case 2: {
        // Only set active city if we have cities selected
        if (selectedCities && selectedCities.length > 0) {
          dispatch(setActiveCity(selectedCities[0]));
        }
        setAddStop(true);
        break;
      }
      case 3: {
        setShowVerifyPage(true);
        break;
      }
    }
  }, [headerStep, isTripCityCreated, selectedCities, dispatch, selectedMethod, busFormData, temporaryFlowState]);

  const RenderSteps = ({customClassName}) => {
    if(isMobile){
      return (
        <MobileSteps 
        current={headerStep} 
        size="small" 
        labelPlacement= "vertical" 
        onChange = {changeSteps} 
        className={`${customClassName}`}>
          <MobileSteps.Step title= "Select Bus"/>
          <MobileSteps.Step title= "Select Cities"/>
          <MobileSteps.Step title= "Add Stops"/>
          <MobileSteps.Step title= "Verify"/>
        </MobileSteps>
      )
    }else{
      return (
        <WebSteps 
        className={`${customClassName}`}
        current={headerStep} size="small" labelPlacement= "vertical" onChange = {changeSteps}>
          <WebSteps.Step title= "Select Bus"/>
          <WebSteps.Step title= "Select Cities"/>
          <WebSteps.Step title= "Add Stops"/>
          <WebSteps.Step title= "Verify"/>
        </WebSteps>
      )
    }
}

    return (
        <div className={`trip-create-root`}>
            <div className="trip-create-inner-div">
               <RenderSteps customClassName={customClassName} />
               {!showVerifyPage?
                 <div className="">
                   {isValidArray(masterCities)&&
                     <TripCreateRoute
                         onCallBackSetDirections={onCallBackSetDirections}
                         masterCities= {masterCities}
                         busesData = {busesData}
                         isTripCityCreated = {isTripCityCreated}
                         addStop = {addStop}
                         tripScheduleId = {tripScheduleId}
                         setShowVerifyPage = {setShowVerifyPage}
                         setHeaderStep = {setHeaderStep}
                         stepDataVal = {stepDataVal}
                         setStepDataVal = {setStepDataVal}
                         selectedSeatNumbers={selectedSeatNumbers}
                         setSelectedSeatNumbers={setSelectedSeatNumbers}
                         setShowSelectCity = {setShowSelectCity}
                         showSelectCity = {showSelectCity}
                         setDistance={setDistance}
                         setDuration={setDuration}
                         addStopComponent={<TripBottomRibbon
                                 distance = {distance}
                                 time = {duration}
                                 setAddStop = {setAddStop}
                                 setShowRibbon = {setShowRibbon}
                                 setHeaderStep = {setHeaderStep}
                                 showRibbon= {showRibbon}
                               />
                         }
                         customClassName={customClassName}
                         childRef={childRef}
                         setCitiesChanged={setCitiesChanged}
                         setSelectedMethod={setSelectedMethod}
                         selectedMethod={selectedMethod}
                         busFormData={busFormData}
                         setBusFormData={setBusFormData}
                         showVerifyPage={showVerifyPage}
                         setAddStop={setAddStop}
                         setSelectedPartner={setSelectedPartner}
                         temporaryFlowState={temporaryFlowState}
                       />
                   }
                 </div>:
                 <div  className="side-verify-nav">
                   {selectedMethod=="time"?<DirectFinalSummary
                     resetAllData={resetAllData}
                     tripScheduleId={tripScheduleId}
                     busFormData={busFormData}
                     partnerSelected={partnerSelected}
                     temporaryFlowState={temporaryFlowState}
                   />:
                   <VerifyTrip
                    resetAllData={resetAllData}
                    scheduleId={tripScheduleId}
                    citiesChanged={citiesChanged}
                   />
                   }
                 </div>
                 }
            </div>
        </div>
    )
}